import "./switch.scss"; // (CSS below)

const CustomSwitch = ({ checked, onChange, disabled }) => {
  return (
    <div>
      <label className="switch" style={{
        cursor: disabled ? 'not-allowed' : 'inherit'
      }}>
        <input
          disabled={disabled}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          style={{
            cursor: disabled ? 'not-allowed' : 'inherit'
          }}
        />
        <span className="slider"></span>
      </label>
    </div>
  );
};

export default CustomSwitch;
